import Media from "emun.media/media.model";
import ServiceBusController from "servicestack/service-bus.controller";

export default class MediaGalleryController extends ServiceBusController {
  $onInit() {
    console.info("$onInit", this);

    const $ctrl = this;
    $ctrl.tags = [];
    if ($ctrl.tagCriteria) {
      $ctrl.bus
        .send(
          "QueryMedia.json?Take=" +
            ($ctrl.take || 1000) +
            "&MediaGallery=TagCriteria&Context=Gallery",
          {
            Realm: $ctrl.realm,
            tagCriteria: $ctrl.tagCriteria,
            OrderBy: '-Position'
          }
        )
        .then(this.onMediaLoad.bind(this));
    } else {
      if ($ctrl.tagId) {
        $ctrl.tagCriteria = { Gallery: $ctrl.tagId };
        $ctrl.bus
          .send(
            "QueryMedia.json?Take=" +
              ($ctrl.take || 1000) +
              "&MediaGallery=TagCriteria&Context=Gallery",
            {
              Realm: $ctrl.realm,
              tagCriteria: $ctrl.tagCriteria,
              OrderBy: "Position"
            }
          )
          .then(this.onMediaLoad.bind(this));
      } else {
        $ctrl.bus
          .send("QueryMediaTags.json?TagKind=Gallery")
          .then(function (res) {
            $ctrl.tags = res.data.results;
            if ($ctrl.tags.length === 1) {
              var tag = $ctrl.tags[0].tagLabel;
              if ($ctrl.$session.isCrm()) {
                $ctrl.$state.transitionTo("media-gallery-tag", { tagId: tag });
              } else {
                window.location = `/gallery-tag?tagId=${tag}`;
              }
            }
          });
      }
    }
  }

  onMediaLoad(res) {
    const $ctrl = this;
    console.info("onMediaLoad", { res, $ctrl });
    $ctrl.media = res.data.results.map((m) => new Media(m));
    $ctrl.results = $ctrl.media;
  }
  viewMediaItem(m) {
    const $ctrl = this;
    if ($ctrl.$session.isCrm()) {
      $ctrl.$state.transitionTo("media-gallery-item", { mediaId: m.id });
    } else {
      window.location = `/gallery-item?mediaId=${m.id}`;
    }
  }
  viewMedia(tag) {
    const $ctrl = this;
    if ($ctrl.$session.isCrm()) {
      $ctrl.$state.transitionTo("media-gallery-tag", { tagId: tag });
    } else {
      window.location = `/gallery-tag?tagId=${tag}`;
    }
  }
}
